/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2021-07-22 18:24:21
 * @LastEditors: voanit
 * @LastEditTime: 2022-01-07 18:22:44
 */
import moment from 'moment'
import { pubKey } from '@/utils/pubkey'
import JSEncrypt from 'jsencrypt'
import ElementUI from 'zz-element-ui'
import Cookies from 'js-cookie'
import { clearStorageExcept, _local } from './storage'
import router from '../router'
//生成uuid
export const setUid = () => {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}
export const debounce = (fn, time) => {
  let timer
  return function (...args) {
    const context = this
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(context, args)
    }, time)
  }
}
export const isPlainObject = obj => Object.prototype.toString.call(obj) === '[object Object]'

export const pick = (target, pickList, condition = item => true) => {
  return pickList.reduce((obj, key) => {
    if (condition(key)) {
      return { ...obj, [key]: target[key] }
    }
    return obj
  }, {})
}
export const isEmptyPlainObject = target => Object.keys(target).length === 0
export const filterParams = (target, exculedValues = ['', null, undefined]) => {
  const result = {}
  for (let key in target) {
    if (Array.isArray(target[key])) {
      let list = []
      for (let i of target[key]) {
        if (['number', 'string'].includes(typeof i)) {
          if (!exculedValues.includes(i)) {
            list.push(i)
          }
        } else if (isPlainObject(i)) {
          let data = filterParams(i, exculedValues)
          if (!isEmptyPlainObject(data)) {
            list.push(i)
          }
        } else {
          list.push(i)
        }
      }
      if (list.length) {
        result[key] = list
      }
    } else if (isPlainObject(target[key])) {
      result[key] = filterParams(result[key], exculedValues)
    } else {
      if (!exculedValues.includes(target[key])) {
        result[key] = target[key]
      }
    }
  }
  return result
}
/**
 * 根据类型处理url，@/components/site-selection
 * @param {*} type   1: 首页，2： 商品，3： 商品系列，4： 外链
 * @param {*} valueObj
 */
export const handleUrlByType = (type, valueObj) => {
  let value = ''
  if (type === 1) {
    // 首页
    value = '/'
  } else if (type === 2) {
    // 商品
    value = `/products/${valueObj.item.seoUrl}` || ''
  } else if (type === 3) {
    // 商品系列
    value = `/collections/${valueObj.item.seoUrl}` || ''
  } else if (type === 5) {
    // 文章
    value = `/blogs/${valueObj.item.seoUrl}` || ''
  } else if (type === 6) {
    // 活动页面
    value = `/promotions/${valueObj.item.seoUrl}` || ''
  } else {
    // 外链
    value = valueObj.value
  }
  return value
}
/**
 * 根据类型处理url，@/components/site-selection
 * @param {*} type   1: 首页，2： 商品，3： 商品系列，4： 外链
 * @param {*} valueObj
 */
export const handleActionNameByType = (type, valueObj) => {
  let name = ''
  if (type === 1) {
    // 首页
    name = '首页'
  } else if (type === 2) {
    // 商品
    name = (valueObj.item && valueObj.item.title) || ''
  } else if (type === 3) {
    // 商品系列
    name = (valueObj.item && valueObj.item.title) || ''
  } else if (type === 5) {
    // 文章
    name = (valueObj.item && valueObj.item.title) || ''
  } else {
    // 外链
    name = valueObj.value
  }
  return name
}
/**
 * 优化数字四舍五入
 * @param {*} num  // 数值
 * @param {*} pz // 小数点位数
 */
export const floatBeat = (num, pz) => {
  let str = String(num)
  if (str.includes('.')) {
    let nrr = str.split('.')
    let n = nrr[1]
    n = '0.' + nrr[1]
    if (nrr[1].substr(pz, 1) === 5 && num.toFixed(pz) < num) {
      let an = Number().toFixed(pz) + '1'

      nrr[1] = Number(n) + Number(an)
    } else {
      nrr[1] = Number(n).toFixed(pz)
    }
    let perz = Number(nrr[0]) + Number(nrr[1])
    return perz.toFixed(pz)
  } else {
    return num.toFixed(pz)
  }
}

/**
 * @desc 数字格式化 - 默认返回 num
 * @param {Array} num - 处理数字
 * @param {Array} precision - 小数点位数
 * @param {Function} separator - 分隔号不传为''
 * @param {Function} pz - 后缀
 */
export const formatNumberMix = (num, precision = 2, separator, pz) => {
  let parts
  let minus = ''
  // 判断是否为数字
  if (!isNaN(parseFloat(num)) && isFinite(num)) {
    // 把类似 .5, 5. 之类的数据转化成0.5, 5, 为数据精度处理做准, 至于为什么
    // 不在判断中直接写 if (!isNaN(num = parseFloat(num)) && isFinite(num))
    // 是因为parseFloat有一个奇怪的精度问题, 比如 parseFloat(12312312.1234567119)
    // 的值变成了 12312312.123456713
    num = Number(num)
    if (num === 0) {
      let zerostr = new Array(precision).fill(0).join('')
      return zerostr ? '0.' + zerostr : '0'
    }
    // 判断负数

    if (num < 0) {
      minus = String(num).substr(0, 1)
      num = Math.abs(num)
    }

    // 处理小数点位数
    num = (typeof precision !== 'undefined' ? floatBeat(num, precision) : num).toString()
    // 分离数字的小数部分和整数部分
    parts = num.split('.')
    // 整数部分加[separator]分隔, 借用一个著名的正则表达式
    parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ''))

    if (pz) {
      return minus ? minus + parts.join('.') + pz : parts.join('.') + pz
    } else {
      return minus ? minus + parts.join('.') : parts.join('.')
    }
  }

  return minus ? minus + num : num
}
/**
 * 根据url出发下载文件
 */
export const handleDownloadClick = (url, fileName) => {
  var form = document.createElement('form')
  form.setAttribute('action', url)
  form.setAttribute('method', 'get')
  form.setAttribute('target', '_blank')
  form.setAttribute('style', 'display:none')
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

// var keyValRe = /([^?&]+?)=([^&]+)?/g
export const getQueryParams = url => {
  url = decodeURIComponent(url || location.href)
  const splitList = url.split('?')
  url = splitList[1] || ''
  const params = url
    .split('&')
    .filter(Boolean)
    .reduce((obj, item) => {
      const [key, value] = item.split('=')
      const val = decodeURIComponent(value)
      if (Array.isArray(obj[key])) {
        obj[key].push(val)
      } else if (typeof obj[key] === 'string') {
        obj[key] = [obj[key], val]
      } else {
        obj[key] = val
      }
      return obj
    }, {})
  return params
}

export const firstCharLowerCase = str => str.charAt(0).toLowerCase() + str.slice(1)

export const isSupportWebp = (function () {
  try {
    return (
      document
        .createElement('canvas')
        .toDataURL('image/webp', 0.5)
        .indexOf('data:image/webp') === 0
    )
  } catch (err) {
    return false
  }
})()

export const thumbnailImage = function (url, width = 150) {
  const containDomain = 'shoplus.net'
  let suffix = `?imageMogr2/thumbnail/${width}x/strip/quality/70!/ignore-error/1`
  if (url && url.indexOf('?') === -1 && url.indexOf(containDomain) > -1) {
    return url + suffix
  }
  return url
}

/**
 * @param {*array} arr
 * @param {*string || function} key
 * @return {*object}
 */
export const keyBy = (arr, key) => {
  const tmp = {}
  let keyFn = i => i[key]
  if (typeof key === 'function') {
    keyFn = key
  }
  if (!Array.isArray(arr)) return tmp
  arr.forEach(i => {
    tmp[keyFn(i)] = i
  })
  return tmp
}
/**
 * @name: 清理cookies
 * @param filter String || Array
 * @return {*}
 */
export const clearAllCookie = filter => {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
  let host = window.location.hostname
  const hostArr = host.split('.')
  hostArr.shift()
  if (keys) {
    for (let i = keys.length; i--;) {
      if (Object.prototype.toString.call(filter) === '[object String]' && filter !== keys[i]) {
        document.cookie = keys[i] + '=0;' + 'domain=' + host + ';expires=' + new Date(0).toUTCString()
        // document.cookie = keys[i] + '=0;' + 'domain=.' + hostArr.join('.') + ';expires=' + new Date(0).toUTCString()
      }
      if (Object.prototype.toString.call(filter) === '[object Array]' && !filter.includes(keys[i])) {
        document.cookie = keys[i] + '=0;' + 'domain=' + host + ';expires=' + new Date(0).toUTCString()
        // document.cookie = keys[i] + '=0;' + 'domain=.' + hostArr.join('.') + ';expires=' + new Date(0).toUTCString()
      } else if (!filter) {
        document.cookie = keys[i] + '=0;' + 'domain=' + host + ';expires=' + new Date(0).toUTCString()
        // document.cookie = keys[i] + '=0;' + 'domain=.' + hostArr.join('.') + ';expires=' + new Date(0).toUTCString()
      }
    }
  }
}

/**
 * @param {*array} target
 * @param {*array} source
 * @param {*string || function} primaryKey
 * @param {*function} mapFn
 * @return {*array}
 */
export const extendByKey = (target, source, primaryKey, mapFn) => {
  let keyFn = i => i[primaryKey]
  if (typeof primaryKey === 'function') {
    keyFn = primaryKey
  }
  const tmp = keyBy(source, keyFn)
  if (!Array.isArray(target)) return target
  return target.map(item => {
    const currentItem = tmp[keyFn(item)]
    if (!currentItem) return mapFn(item, null)
    return mapFn(item, currentItem)
  })
}

// 深拷贝 兼容数组
function isObject(obj) {
  return typeof obj === 'object' && obj != null
}
export const cloneDeep = source => {
  if (!isObject(source)) return source // 非对象返回自身
  const target = Array.isArray(source) ? [] : {}
  for (const key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (isObject(source[key])) {
        target[key] = cloneDeep(source[key]) // 注意这里
      } else {
        target[key] = source[key]
      }
    }
  }
  return target
}
/**
 * @desc 滚动关闭提示
 */
export const hidePopper = () => {
  // console.log('el-popper::::::', document.querySelectorAll('.el-popper'), )
  // for (let i of document.querySelectorAll('.el-popper')) {
  //   if(i.style && i.style.display !== 'none') {
  //     i.style.display = 'none'
  //   }
  // }
}

export const listToTree = (arr, limit = 4) => {
  const fn = (arr, limit, item) => {
    arr.forEach(ise => {
      if (
        ise.level === item.level + 1 &&
        ise.actionCode
          .split('::')
          .slice(0, item.level)
          .join('::') === item.actionCode
      ) {
        item.children.push(ise)
        item.children.sort((a, b) => a.sort - b.sort)
      }
    })
    return item
  }
  const authArr = arr.map(item => {
    let itemCode = item.actionCode.split('::')
    item.level = item.actionCode.split('::').length
    item.title = item.actionName
    const { level, actionCode } = item
    item.name = itemCode[level - 1] + '::' + item.actionId
    if (limit === level) {
      return item
    } else if (limit > level) {
      item.children = []
    }
    return item
  })
  return authArr
    .map(item => {
      if (item.children) {
        item = fn(authArr, limit, item)
      }
      return item
    })
    .filter(item => item.level === 1)
}

// 计算浏览器滚动条宽度
let scrollBarWidth
export const BarWidth = function () {
  if (scrollBarWidth !== undefined) return scrollBarWidth
  const outer = document.createElement('div')
  outer.className = 'el-scrollbar_wrap'
  outer.style.visibility = 'hidden'
  outer.style.width = '100px'
  outer.style.position = 'absolute'
  outer.style.top = '-99999px'
  document.body.appendChild(outer)
  const widthNoScroll = outer.offsetWidth
  outer.style.overflow = 'scroll'
  const inner = document.createElement('div')
  inner.style.width = '100%'
  outer.appendChild(inner)
  const widthWithScroll = inner.offsetWidth
  outer.parentNode.removeChild(outer)
  scrollBarWidth = widthNoScroll - widthWithScroll
  return scrollBarWidth
}
export const backLengedData = (arr1, arr2, target = 'date') => {
  if (arr1.length && arr2.length) {
    let str1 = moment(arr1[0][target]).format('MM月DD日')
    str1 += '至'
    str1 += moment(arr1[arr1.length - 1][target]).format('MM月DD日')
    let str2 = moment(arr2[0][target]).format('MM月DD日')
    str2 += '至'
    str2 += moment(arr2[arr2.length - 1][target]).format('MM月DD日')
    return [str1, str2]
  } else {
    return ['', '']
  }
}
export const rotateReport = (_this, data = []) => {
  if (_this.$el.clientWidth > 1600 && data.length > 6) {
    return 30
  } else if (_this.$el.clientWidth > 1300 && data.length > 6) {
    return 30
  } else {
    return 0
  }
}

// blob文件流下载
export const downloadBlobFile = function (source, option, filename = '', downloadJson = false) {
  const myBlob = new Blob([source], option)
  if (myBlob.type === 'application/json' && !downloadJson) {
    return myBlob
  }
  const link = document.createElement('a')
  link.href = URL.createObjectURL(myBlob)
  link.setAttribute('download', filename) // 设置下载文件名称
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
export function createHash(hashLength) {
  // 默认长度 24
  return Array.from(Array(Number(hashLength) || 24), () => Math.floor(Math.random() * 36).toString(36)).join('')
}
export function formatThousandMark(value) {
  let curValue = String(value).replace(/\$|\\%/g, '')
  const fuValue = String(value).indexOf('-') === 0
  const dollarIndex = String(value).includes('$')
  const percentIndex = String(value).includes('%')
  if (Number(curValue)) {
    if (fuValue) {
      curValue = curValue.substring(1, 1000)
    }
    const str = String(curValue)
    if (Number(curValue) >= 1000) {
      const intLength = str.indexOf('.') !== -1 ? str.indexOf('.') : str.length
      const deciStr = str.substring(intLength, 1000)
      const attrReverse = str
        .split('')
        .slice(0, intLength)
        .reverse()
      for (let i = attrReverse.length - 2; i >= 0; i--) {
        if ((i + 1) % 3 === 0) {
          attrReverse.splice(i + 1, 0, ',')
        }
      }
      return dollarIndex
        ? '$' + attrReverse.reverse().join('') + deciStr
        : percentIndex
          ? attrReverse.reverse().join('') + deciStr + '%'
          : fuValue
            ? '-' + attrReverse.reverse().join('') + deciStr
            : attrReverse.reverse().join('') + deciStr
      // while()
    } else {
      return value
    }
  } else {
    return value
  }
}
export function dataCheck(data, str = '--') {
  if (data === null || data === undefined || data === '') {
    return str
  } else {
    return data
  }
}
export function copy(text) {
  let input = null
  if (document.getElementById('inputCopy')) {
    input = document.getElementById('inputCopy')
    input.value = text
  } else {
    input = document.createElement('input')
    input.value = text
    input.id = 'inputCopy'
    input.style = 'position:absolute;top: -9999px;left: -9999px;'
    document.body.appendChild(input)
  }
  input.select()
  document.execCommand('Copy')
  ElementUI.Message.success(window.$t('system::tip::copy_success'))
}
export function deepClone(obj) {
  if (obj === null) return null
  if (typeof obj !== 'object') return obj
  if (obj.constructor === Date) return new Date(obj)
  if (obj.constructor === RegExp) return new RegExp(obj)
  var newObj = new obj.constructor() // 保持继承链
  for (var key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      // 不遍历其原型链上的属性
      var val = obj[key]
      newObj[key] = typeof val === 'object' ? deepClone(val) : val // 使用arguments.callee解除与函数名的耦合
    }
  }
  return newObj
}

export function objectItemChangeNumber(item) {
  for (const i in item) {
    item[i] = item[i] ? (isNaN(Number(item[i])) ? item[i] : Number(item[i])) : ''
  }
  return item
}

// 密码加密
export const passwordEncrypt = password => {
  let jsencrypt = new JSEncrypt()
  jsencrypt.setPublicKey(pubKey)
  return jsencrypt.encrypt(password.trim())
}

// 重定向登录页
export const redictToLogin = account => {
  clearStorageExcept()
  document.cookie = `token=0;domain=.shoplus.net;expires=${new Date(0).toUTCString()}`
  const preAccount = account || Cookies.get('preAccount')
  if (preAccount == 1) {
    window.location.href = `${window.location.origin}/zhizh-login`
  } else if (preAccount == 2) {
    window.location.href = `${window.location.origin}/pearlgo-login`
  } else if (preAccount == 3) {
    window.location.href = `${window.location.origin}/gule-login`
  } else {
    let url = process.env.VUE_APP_LOGINURL
    if (router.currentRoute.matched.length > 0 && router.currentRoute.matched[0].name == 'personal') {
      url += '?redict_url=//console.shoplus.net/personal'
    }
    window.location.href = url
  }
}

// personTurn旧个人中心跳转新个人中心
export const toPersonalPage = personTurn => {
  let url = process.env.VUE_APP_PERSONAL
  const token = _local.get('saasToken') || Cookies.get('saasToken')
  const preAccount = Cookies.get('preAccount')
  let backUrl = personTurn || (router.name === 'expired' ? window.location.origin : window.location.href)
  backUrl = encodeURIComponent(backUrl)
  url += `?token=${token}&preAccount=${preAccount}&backUrl=${backUrl}`
  if (personTurn) {
    window.location.replace(url)
  } else {
    window.location.href = url
  }
}
